import { render, staticRenderFns } from "./SchoolCreateView.vue?vue&type=template&id=6c424321&"
import script from "./SchoolCreateView.vue?vue&type=script&lang=js&"
export * from "./SchoolCreateView.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCreateView.vue?vue&type=style&index=0&id=6c424321&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports